//
// Module for Quick Payment Entry
//
rs.module("content/fund/account/quickpaymententry",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {

            // Unpack js selectors
            var quickPaymentEntry = $.js(jsSelectors.quickPaymentEntry);
            var employerSelect = quickPaymentEntry.js(jsSelectors.employerSelect);

            // populate grid with vouchers associated with the employer
            employerSelect.change(function () {
                gridModule.update(
                    ajaxUrls.getGridData,
                    { employerKey: this.value },
                    lrsGridApi.agGridApi,
                    function done() { }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);